// ----------------------------------------------------------------------
// <copyright file="Izenda.DataGridSearch.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module DataGridSearch component
 * @example
 *   <DropDownList></DropDownList>
 *   <TextBox></TextBox>
 *   <SearchButton></SearchButton>
 */
!(function() {
  var React = require('react');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var SearchTextBox = require('share/components/controls/Izenda.SearchTextBox');
  var UiState = require('logic/Izenda.UiState');
  var classnames = require('classnames');
  const { debounce, noop, isNil, isString } = require('lodash/fp');
  var DataGridSearch = React.createClass({
    searchProperty: '',

    propTypes: {
      searchPropClass: React.PropTypes.string,
      searchInputClass: React.PropTypes.string,
      options: React.PropTypes.oneOfType([React.PropTypes.object.isRequired, React.PropTypes.array.isRequired]),
      value: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
      searchValue: React.PropTypes.string,
      onChange: React.PropTypes.func,
      onSearchPropertiesChange: React.PropTypes.func,
      onSizeStateChange: React.PropTypes.func
    },

    getInitialState: function() {
      var props = this.props;

      return {
        searchProperty: props.value,
        searchInput: props.searchValue || '',
        isMinState: UiState.isMobile,
        isMobile: UiState.isMobile
      };
    },

    componentWillMount: function() {
      this.registerOnChangeFn(this.props);
    },

    registerOnChangeFn: function(props) {
      this.debounceOnChange = debounce(300, props.onSearchPropertiesChange || noop);
    },

    componentWillReceiveProps: function(nextProps) {
      this.setState({
        searchProperty: nextProps.value,
        // need to set searchInput to empty string so only check if nextProps is null or undefined
        searchInput: isNil(nextProps.searchValue) ? this.state.searchInput : nextProps.searchValue
      });
      if (this.props.onSearchPropertiesChange !== nextProps.onSearchPropertiesChange) {
        this.registerOnChangeFn(nextProps);
      }

      if (this.state.isMobile !== UiState.isMobile) {
        this.setState({
          isMinState: UiState.isMobile,
          isMobile: UiState.isMobile
        });
      }
    },

    renderFullState: function() {
      var classes = classnames('izenda-DataGridSearch', this.props.className);
      var isResponsive = this.props.responsive || false;
      var isMobile = this.state.isMobile || false;
      return (
        <div className={classes} ref="dataGridSearch" aria-expanded="false">
          <div className="u_tableCell izenda-DataGridSearch-select">
            <DropDown
              options={this.props.options}
              value={this.state.searchProperty}
              labelField="label"
              valueField="value"
              onChange={this._onDropdownChange}
              className={this.props.searchPropClass}
              autoWidth
            />
          </div>

          <SearchTextBox
            className={this.props.searchInputClass}
            onChange={this.changeSearchText}
            value={this.state.searchInput}
            clickable
            onKeyPress={this._onKeyPress}
            onClick={this._onSearch}
          />
          {isMobile &&
            isResponsive && (
              <div className="izenda-DataGridSearch-cancel">
                <button type="button" className="btn btn-icon" onClick={this.showMin}>
                  <span className="icon-cancel-circled" />
                </button>
              </div>
            )}
        </div>
      );
    },

    renderMinState: function() {
      var classes = classnames('izenda-DataGridSearch', this.props.className);

      return (
        <div className={classes} ref="dataGridSearch" aria-expanded="false">
          <a className="izenda-DataGridSearch-iconSearch" onClick={this.onMinSearchIconClick}>
            <span className="icon-search" />
          </a>
        </div>
      );
    },

    render: function() {
      if (!this.props.responsive) return this.renderFullState();
      return this.state.isMinState ? this.renderMinState() : this.renderFullState();
    },

    onMinSearchIconClick: function(e) {
      e.preventDefault();
      this.showFull();
      return false;
    },

    showFull: function() {
      var onSizeStateChange = this.props.onSizeStateChange;
      this.setState(
        {
          isMinState: false
        },
        function() {
          onSizeStateChange && onSizeStateChange(this.state.isMinState);
        }
      );
    },

    showMin: function() {
      var onSizeStateChange = this.props.onSizeStateChange;
      this.setState(
        {
          isMinState: true
        },
        function() {
          onSizeStateChange && onSizeStateChange(this.state.isMinState);
        }
      );
    },

    changeSearchText: function(e) {
      this.setState({ searchInput: e.target.value });
      this.debounceOnChange(this.state.searchProperty, e.target.value);
    },

    _onDropdownChange: function(obj) {
      this.setState({ searchProperty: obj.value });
      if (this.state.searchInput) {
        this._onSearch(obj.value);
      }

      this.props.onSearchPropertiesChange && this.props.onSearchPropertiesChange(obj.value, this.state.searchInput);
    },

    _onKeyPress: function(e) {
      if (e.key === 'Enter') {
        this._onSearch();
      }
    },

    _onSearch: function(value) {
      var state = this.state;
      var keySearch = isString(value) ? value : state.searchProperty;
      this.props.onSearch(keySearch, state.searchInput);
    }
  });

  module.exports = DataGridSearch;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/Izenda.DataGridSearch.jsx